import { createStore } from 'vuex';

export default createStore({
  state: {
    _this: '',
    themetype: '浅色',
    getUserInfo: {
    }, // 用户信息
    memberInfo: {
    }, // 会员信息
    wechatPayGoodsInfo: {
    }, // 购买列表
    avatar: '', // 头像
    nickName: '', // 呢称
    sessionId: '', // 登录标识
    userId: '',
    openid: '',
    isWX: false, // 是否微信浏览器
    // isLogin: false, // 是否登录
    // isVIP: false, // 是否会员
    customerMobile: '', // 手机号
    nowTabbarIndex: 0,
    isLoading: false,
    isShowPage: true,
    popDalogue: { // 当前机器人信息
      // imgUrl: 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKRDBYCJsicibSiaJ9MP425x38dKQoRFIoUH52MaibPX391TwPlVbicY1ibkSfZZcnSaIZ2icXaAuRRJ8jMg/132',
      // appName: 'gpt3.4'
    },
    nowWindow: { // 当前窗口
      windowName: '新对话',
      windowId: ''
    },
    msgList: [// 对话数据
      // {
      //   appId: 1004,
      //   content: '写一篇关于做饭的论文',
      //   createDatetime: '2024-11-14 23:02:41',
      //   recordStatus: 1,
      //   role: 'user',
      //   sessionRecordId: 45,
      //   userId: 4,
      //   windowId: 86
      // },
      // {
      //   appId: 1004,
      //   content: '写一篇关于做饭的论文<br><br>1111',
      //   createDatetime: '2024-11-14 23:02:41',
      //   recordStatus: 1,
      //   role: 'assistant',
      //   sessionRecordId: 45,
      //   userId: 4,
      //   windowId: 86
      // },
      // {
      //   appId: 1004,
      //   content: '我全面坦露自己的软弱，<span style="color: #f0ad4e;">捶胸<br><br>顿足</span>，小丑般无理取闹。可万物充耳不闻。我无数遍讲诉自己的孤独，又讲诉千万人的千万种孤独。越讲越尴尬，独自站在地球上，无法收场。',
      //   createDatetime: '2024-11-14 23:02:41',
      //   recordStatus: 1,
      //   role: 'assistant',
      //   sessionRecordId: 45,
      //   userId: 4,
      //   windowId: 86
      // }
    ],
    // 历史对话列表
    popDalogueHistory: [
    ],
    AIDalogueMarket: [
    ],
    activeIndex: '',
    appTypeList: [
    ],
    tabbarList: [
      {
        index: 1,
        name: '对话',
        pageUrl: '/HomePage',
        icon: 'chat-o'
      },
      {
        index: 4,
        name: 'AI市场',
        pageUrl: '/HealthServices',
        icon: 'shop-o'
      },
      // {
      //   index: 2,
      //   name: '语音',
      //   pageUrl: '/VoiceComponent',
      //   icon: 'phone-circle-o'
      // },
      {
        index: 5,
        name: '我的',
        pageUrl: '/MineHealth',
        icon: 'manager-o'
      }
    ],
    // 默认展示
    HSKindList: [
      // {
      //   name: '我的常用',
      //   nowShow: true,
      //   childListName: 'HSMyCommonList'
      // },
      // {
      //   name: 'AI聊天',
      //   nowShow: false,
      //   childListName: 'HSInquiryServiceList'
      // },
      // {
      //   name: 'AI写作',
      //   nowShow: false,
      //   childListName: 'HSBasicServiceList'
      // }
    ],
    // AI市场 我的常用
    HSMyCommonList: [],
    // AI市场 AI聊天
    HSInquiryServiceList: [
    //   {
    //     name: 'AI聊天4o',
    //     iconUrl: require('@/assets/img/healthServices/hs_tuwenwenzhen.png'),
    //     kind: 'HSInquiryServiceList',
    //     kindIndex: '1',
    //     isCommon: false,
    //     clickCount: 0,
    //     isAdd: 0
    //   },
    //   {
    //     name: 'AI聊天免费版',
    //     iconUrl: require('@/assets/img/healthServices/hs_zaixianwenzhen.png'),
    //     kind: 'HSInquiryServiceList',
    //     kindIndex: '2',
    //     isCommon: false,
    //     clickCount: 0,
    //     isAdd: 0
    //   },
    //   {
    //     name: 'AI聊天3.5',
    //     iconUrl: require('@/assets/img/healthServices/hs_xinlizixun.png'),
    //     kind: 'HSInquiryServiceList',
    //     kindIndex: '3',
    //     isCommon: false,
    //     clickCount: 0,
    //     isAdd: 0
    //   }
    // ],
    // // AI市场 AI写作
    // HSBasicServiceList: [
    //   {
    //     name: '文章创作',
    //     iconUrl: require('@/assets/img/healthServices/hs_lianxikefu.png'),
    //     kind: 'HSBasicServiceList',
    //     kindIndex: '1',
    //     isCommon: false,
    //     clickCount: 0,
    //     isAdd: 0
    //   }
    ],
    // 我的 登录列表
    MHGongGongMyServiceList: [
      // {
      //   name: '联系客服',
      //   iconUrl: require('@/assets/img/mineHealth/mh_lianxikefu.png')
      // },
      // {
      //   name: '退出登录',
      //   iconUrl: require('@/assets/img/mineHealth/mh_tuichudenglu.png'),
      //   iconUrl1: require('@/assets/img/mineHealth/miaoshajiantou.png')
      // }
    ],
    // 我的 未登录列表
    MHMyServiceList: [
      // {
      //   name: '联系客服',
      //   iconUrl: require('@/assets/img/mineHealth/mh_lianxikefu.png')
      // }
    ],
    // -------------------------------------------------------------------------
    // 模式  ordinary-普通版  care-关怀版
    version: 'ordinary',
    customerInfo: '',
    customerArea: '-1',
    isImprove: false,
    isGuDong: false,
    isNewPeople: false,
    // 网上药房 药房列表
    // 首页非股东定位
    homePageNoGuDongAddress: '',
    // 定位授权
    linePharmacyAddressFlag: false,
    linePharmacyAddress: '',
    linePharmacyAddressLng: '', // 地址经度
    linePharmacyAddressLat: '', // 地址纬度
    nearlyPharmacyList: [],
    totalPrice: ''
  },
  getters: {
  },
  mutations: {
    changeStoreDataFun (state, params) {
      state[params.key] = params.value;
    },
    // 修改地址
    changeAddressDataFun (state, params) {
      if (params.length) {
        params.forEach(element => {
          state[element.key] = element.value;
        });
      } else {
        state[params.key] = params.value;
      }
    }
  },
  actions: {
    /**
     * 纯赋值方法
     * @param 对象类型或数组类型
     * @param {*} key  必传
     * @param {*} value  必传
    */
    changeStoreData ({ commit }, value) {
      if (value.length) {
        value.forEach(element => {
          commit('changeStoreDataFun', element);
        });
      } else {
        commit('changeStoreDataFun', value);
      }
    },
    // 切换健康服务状态
    changeHSKindState ({ commit, state }, index) {
      let HSKindList = state.isGuDong ? state.HSGuDongKindList : state.HSKindList;
      let nowShowIndex = '';
      HSKindList.forEach((element, index) => {
        if (element.nowShow === true) {
          nowShowIndex = index;
        }
      });
      if (nowShowIndex !== index) {
        HSKindList[nowShowIndex].nowShow = false;
        HSKindList[index].nowShow = true;
        commit('changeStoreDataFun', { key: 'HSKindList', value: HSKindList });
      }
    },
    /**
     * 更新我的常用功能
     * @param {*} type  必传 可选值为delete|add|edit
     * @param {*} index  索引值
     * @param {*} param  传值为对象  add时为需要追加的项  edit时为需要修改的key及value
    */
    changeHSList ({ commit, state }, value) {
      let editList = state[value.listName];
      if (value.type === 'delete') {
        console.log('shanchu');
        editList.splice(value.index, 1);
      } else if (value.type === 'add') {
        editList.splice(0, 0, value.param);
      } else if (value.type === 'edit') {
        console.log('xiugai', value);
        let keys = Object.keys(value.param);
        let item = value.listName === 'HSMyCommonList' ? editList[value.index] : editList.find(item => parseInt(item.kindIndex) === parseInt(value.index));
        keys.forEach((element) => {
          item[element] = value.param[element];
        });
      }
      commit('changeStoreDataFun', { key: value.listName, value: editList });
    }
  }
});
